export default "__VITE_ASSET__CTR7HPDe__"